"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUi = require("@100mslive/react-ui");
var _utils = require("../../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var PreviewName = function PreviewName(_ref) {
  var name = _ref.name,
    onChange = _ref.onChange,
    onJoin = _ref.onJoin,
    enableJoin = _ref.enableJoin;
  var formSubmit = function formSubmit(e) {
    e.preventDefault();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Form, {
    onSubmit: formSubmit,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: '100%'
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
      type: "submit",
      disabled: !name || !enableJoin,
      onClick: onJoin,
      style: btnStyle,
      children: (0, _utils.isStreamingKit)() ? "Join Studio" : "Join Room"
    })]
  });
};
var Form = (0, _reactUi.styled)("form", {
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: "$4",
  mt: "$10",
  mb: "$10"
});
var btnStyle = {
  background: "#ff6d00",
  border: "1px solid #ff6d00"
};
var _default = PreviewName;
exports["default"] = _default;